module.exports = __webpack_public_path__ + "static/media/2.5fface63.jpg";